import React, { useId } from 'react';

export const EMPTY_PROXY = { scheme: 'http', host: '', port: '', username: '', password: '', useLogin: false };

/** Checks done before sending; the server re-checks (public address, characters). */
export function proxyFieldsError(value, { passwordOptional = false } = {}) {
  const host = String(value?.host || '').trim();
  const port = Number(value?.port);
  if (!host) return 'Enter the proxy host name or IP address.';
  if (/\s|\/|:/.test(host)) return 'Enter only the host name or IP address, without http:// or a port.';
  if (!Number.isInteger(port) || port < 1 || port > 65535) return 'Enter a port between 1 and 65535.';
  if (value?.useLogin) {
    if (!String(value.username || '').trim()) return 'Enter the proxy username.';
    if (!passwordOptional && !String(value.password || '')) return 'Enter the proxy password.';
  }
  return '';
}

/** The request body for a proxy (login only when it needs one). */
export function proxyPayload(value) {
  return {
    scheme: value.scheme || 'http',
    host: String(value.host || '').trim(),
    port: Number(value.port),
    username: value.useLogin ? String(value.username || '').trim() : '',
    password: value.useLogin ? String(value.password || '') : '',
  };
}

export default function ProxyFields({ value, onChange, disabled = false, passwordPlaceholder = '' }) {
  const id = useId();
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="scan-network-proxy-fields">
      <div className="scan-network-proxy-row">
        <label className="scan-network-field" htmlFor={`${id}-scheme`}>
          <span>Type</span>
          <select id={`${id}-scheme`} className="scan-network-select" value={value.scheme} onChange={(e) => set({ scheme: e.target.value })} disabled={disabled}>
            <option value="http">HTTP proxy</option>
            <option value="https">HTTPS proxy</option>
          </select>
        </label>
        <label className="scan-network-field scan-network-field--grow" htmlFor={`${id}-host`}>
          <span>Host</span>
          <input
            id={`${id}-host`} className="scan-network-input" value={value.host} placeholder="proxy.example.com"
            onChange={(e) => set({ host: e.target.value })} disabled={disabled} autoComplete="off" spellCheck="false"
          />
        </label>
        <label className="scan-network-field scan-network-field--port" htmlFor={`${id}-port`}>
          <span>Port</span>
          <input
            id={`${id}-port`} className="scan-network-input" value={value.port} inputMode="numeric" placeholder="3128"
            onChange={(e) => set({ port: e.target.value.replace(/[^0-9]/g, '').slice(0, 5) })} disabled={disabled}
          />
        </label>
      </div>
      <label className="scan-network-check" htmlFor={`${id}-login`}>
        <input id={`${id}-login`} type="checkbox" checked={Boolean(value.useLogin)} onChange={(e) => set({ useLogin: e.target.checked })} disabled={disabled} />
        This proxy needs a username and password
      </label>
      {value.useLogin ? (
        <div className="scan-network-proxy-row">
          <label className="scan-network-field scan-network-field--grow" htmlFor={`${id}-user`}>
            <span>Username</span>
            <input
              id={`${id}-user`} className="scan-network-input" value={value.username}
              onChange={(e) => set({ username: e.target.value })} disabled={disabled} autoComplete="off"
            />
          </label>
          <label className="scan-network-field scan-network-field--grow" htmlFor={`${id}-pass`}>
            <span>Password</span>
            <input
              id={`${id}-pass`} className="scan-network-input" type="password" value={value.password}
              placeholder={passwordPlaceholder} onChange={(e) => set({ password: e.target.value })} disabled={disabled}
              autoComplete="new-password"
            />
          </label>
        </div>
      ) : null}
      <p className="settings-modal-card-hint">
        The proxy sees xSPECTRE&apos;s scanning addresses. Allow-list them on the proxy if it restricts who can connect.
      </p>
    </div>
  );
}
